// extracted by mini-css-extract-plugin
export default {"wrapper":"rXipodrgnjLtUQ7bTY_V","editButton":"OKTKBOnjVTmtB4xzP5vV"};